import React from 'react'
import { Form, Typography } from 'antd'
import PropTypes from 'prop-types'

import { formatDateFromNow } from '../../../core/utils'

import { EMPTY_PLACEHOLDER } from '../../constants'
import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormDate = ({ name, label, labelAbove, getFieldValue, showColon }) => (
  <Form.Item
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    name={name}
    label={
      <Typography.Text>{formatFormItemLabel(label, showColon)}</Typography.Text>
    }
  >
    <Typography.Paragraph>
      {getFieldValue(name)
        ? formatDateFromNow(getFieldValue(name))
        : EMPTY_PLACEHOLDER}
    </Typography.Paragraph>
  </Form.Item>
)

FormDate.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  getFieldValue: PropTypes.func.isRequired,
  labelAbove: PropTypes.bool,
  showColon: PropTypes.bool,
}

FormDate.defaultProps = {
  label: '',
  labelAbove: false,
  showColon: false,
}

export default FormDate
